const e={display:"flex",justifyContent:"center",alignItems:"center"},t=e=>({maxWidth:e,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",minWidth:0});export{e as flexCenter,t as textEllipsis};
//# sourceMappingURL=styles.js.map
